import Modifier from 'ember-modifier';

import 'rise-navigation';

/**
 * Replicates: https://www.usbr.gov/js/components/left-nav.js and
 * https://www.usbr.gov/js/components/navigation.js
 * Turns menus into a togglable dropdowns on mobile screen sizes.
 */
export default class CreateMenuToggleModifier extends Modifier {
  initialized = false;

  modify(element) {
    if (this.initialized) {
      return;
    }
    this.initialized = true;
    riseNavigation.initMainMenu().createMenuToggle(element);
  }
}
